import type { Route } from "vue-router";
import { ROUTE_NAMES } from "@/router/route-names";

export const isOrderCreationRoute = (route: Route) => {
  if (route.name) {
    return Object.values(ROUTE_NAMES.ORDERS_NEW).includes(route.name);
  }
  return route.path.startsWith("/new-order");
};
